import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  hover?: boolean;
  className?: string;
}

const Card = ({ children, hover = true, className = '' }: CardProps) => (
  <div className={`card ${hover ? 'card-hover' : ''} ${className}`}>
    {children}
  </div>
);

export default Card;
